var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 368,
    viewBox: "0 0 368 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.961 367.929C285.561 367.929 367.929 285.569 367.929 183.968C367.929 82.3674 285.561 0 183.961 0C82.3602 0 0 82.3674 0 183.968C0 285.569 82.3602 367.929 183.961 367.929ZM183.961 91.9804C202.155 91.979 219.94 97.3727 235.069 107.48C250.197 117.586 261.988 131.952 268.952 148.761C275.915 165.569 277.738 184.065 274.189 201.909C270.641 219.754 261.88 236.145 249.016 249.011C236.152 261.876 219.761 270.638 201.917 274.187C184.073 277.737 165.576 275.916 148.767 268.954C131.959 261.992 117.592 250.202 107.484 235.074C97.3755 219.947 91.9808 202.162 91.9808 183.968C91.9808 159.573 101.671 136.176 118.92 118.926C136.17 101.675 159.565 91.9823 183.961 91.9804Z",
    fill: "#F47523"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.f34b4d095a49665d3f6345e5f84b015d.svg";
export { ForwardRef as ReactComponent };